import TravelRuleTableFilter from './TravelRuleTableFilter'

export default TravelRuleTableFilter
